import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { COLORS } from "styles/colors";
import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";

export const Container = styled(InnerPaddingWrapper)`
  ${FLEX.FlexCenterStart};
  padding-top: 50px;
  padding-bottom: 50px;
  height: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

export const UtilWrapper = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  ${mediaQuery.isTablet} {
    grid-template-columns: repeat(3, 1fr);
  }
  ${mediaQuery.isMobile} {
    grid-template-columns: repeat(1, 1fr);
  }

  > li {
    cursor: pointer;
    background-color: #448ed2;
    padding: 20px;
    color: ${COLORS.WHITE};
    border-radius: 4px;
    height: 120px;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 10px;

    h5 {
      font-size: ${calcRem(22)};
      font-weight: 500;

      ${FLEX.FlexStartCenter};
      gap: 6px;

      > button {
        color: ${COLORS.WHITE};
        opacity: 0.8;
      }
    }

    .desc {
      font-size: ${calcRem(14)};
    }
  }
`;

export const AdminUnlockStyled = {
  Container: styled.div`
    width: 100%;
    max-width: 720px;

    > p {
      color: ${({ theme }) => theme.COLORS.GRAY};
      line-height: ${calcRem(20)};
    }
    ${mediaQuery.isTablet} {
      width: 100%;
    }
  `,

  FormWrapper: styled.div`
    width: 90%;
    max-width: 700px;
    ${FLEX.FlexStartEnd};
    flex-direction: column;
    gap: 30px;
    margin-top: 30px;

    ${mediaQuery.isMobile} {
      width: 100%;
    }
    .common-modal-input {
      flex-direction: row;
      align-items: center;

      ${mediaQuery.isTablet} {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }

      .modal-input-label-title {
        flex: 1;
        font-size: ${calcRem(16)};
        width: 140px;
      }
    }

    .device-radio {
      ${FLEX.FlexStartCenter};
      width: 100%;

      > label {
        flex: 1;
      }
    }

    .form-input-inner {
      width: 100%;
      ${FLEX.FlexStartStart};
      flex-direction: column;
      position: relative;
    }
    .validate-word {
      margin: 6px 0 -28px 0;
    }
  `,
  ToggleText: styled.span`
    color: ${({ theme }) => theme.COLORS.SELECTED};
    cursor: pointer;
    ${FLEX.FlexStartCenter};
    gap: 4px;
    padding: 0 0 10px;

    -webkit-user-drag: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* 표준 */
  `,
  RetrieveInfoWrapper: styled.ul`
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY};
    background: ${({ theme }) => theme.COLORS.PRIMARY3};
    padding: 10px 20px;
    color: ${({ theme }) => theme.COLORS.GRAY};
    font-size: ${calcRem(14)};
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 6px;

    > li {
      ${FLEX.FlexStartCenter};
      gap: 10px;

      b {
        font-weight: 500;
      }
    }
  `,
  ButtonWrapper: styled.div`
    ${FLEX.FlexEndEnd};
    flex-direction: column;
    gap: 10px;
    width: 100%;
    .button-wrapper {
      padding: 0;
      width: 100%;
    }
  `,
  Otp: styled.div`
    width: 100%;
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.COLORS.BUTTONS2};
    padding: 20px 0;
    ${FLEX.FlexCenterCenter};
    gap: 6px;
    font-size: ${calcRem(24)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-family: "JetBrains Mono", monospace;

    button {
      ${FLEX.FlexCenterCenter};
      color: ${({ theme }) => theme.COLORS.WHITE};
    }
  `,
};

export const AutoInputStyled = {
  Container: styled.div`
    width: 100%;
    ${FLEX.FlexStartCenter};
    gap: 6px;

    > div {
      flex: 1;
      display: flex;
      align-items: center;
    }

    input {
      flex: 1;
      min-width: 0;
      padding: 10px 0;
      text-align: center;
    }
  `,

  Separator: styled.span`
    margin: 0 4px;
    flex: 0;
    font-weight: bold;
    color: ${({ theme }) => theme.COLORS.WHITE};
  `,
};
